import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000

export const useIntegrationsStore = defineStore('integrations', {
  state: () => ({
    integrations: [],
    fetchedAt: null,
    loading: false,
    error: null,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,

    connectedCount: (state) =>
      state.integrations.filter((i) => i.user_integration_id !== null).length,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid && this.integrations.length > 0) return
      await this.fetchIntegrations()
    },

    async fetchIntegrations() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/api/v1/integrations', {}, false)
        if (!res.js_error && res.response.success) {
          this.integrations = res.response.data
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load integrations.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    updateIntegration(integrationId, patch) {
      const idx = this.integrations.findIndex((i) => i.integration_id === integrationId)
      if (idx !== -1) Object.assign(this.integrations[idx], patch)
    },

    setAll(integrations) {
      this.integrations = integrations
      this.fetchedAt = Date.now()
    },

    invalidate() {
      this.fetchedAt = null
    },
  },
})
